/**
  Um eine Dropdown-Option in einem Contact Form 7-Formular vorauszuwählen, wenn ein Benutzer von einer bestimmten Stellenanzeige-Seite kommt
**/

const initApplicationSelect = () => {
    function getQueryParam(param) {
        const urlParams = new URLSearchParams(window.location.search);
        return urlParams.get(param);
    }

    // Abrufen des Parameters 'stellenID'
    const stellenID = getQueryParam('stellenID');
    if (stellenID) {
        const selectElement = document.getElementById('joboffer');
        if (selectElement) {
            Array.from(selectElement.options).forEach(option => {
                if (option.getAttribute('data-id') === stellenID) {
                    selectElement.value = option.value;
                    option.selected = true;
                }
            });
        }
    }

};

export default initApplicationSelect;
